var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Site } from '@debbie/common/dist';
import { getBillingName, } from '@debbie/common/dist/economy/billing';
import * as billingsAPI from '@debbie/cortex/dist/api/billing';
import THEME from '../theme';
import { Send } from './Icons';
import PlusSquare from './Icons/PlusSquare';
import X from './Icons/X';
import { Badge, CopyToClipboard } from '.';
import { useAllCreditors } from '@debbie/cortex/dist/creditors';
import { h } from '@debbie/cortex/dist';
export const getBillingIdentity = (billing, lang) => getBillingName(billing);
const Billing = (props) => {
    const { billing } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const allCreditorsLoadable = useAllCreditors();
    const allCreditors = h.hasData(allCreditorsLoadable)
        ? allCreditorsLoadable.data
        : null;
    const creditor = allCreditors &&
        allCreditors.find((c) => c.creditorId === billing.creditorId);
    const identity = getBillingIdentity(billing, lang);
    return (React.createElement("tr", { onClick: props.onClick },
        React.createElement("td", { style: { width: '40px' } },
            React.createElement(PlusSquare, { style: { cursor: 'pointer' } })),
        React.createElement("td", { style: { width: '1px' } }, moment(billing.date).isAfter(moment().startOf('day')) && React.createElement(Circle, null)),
        React.createElement("td", { style: { width: '1%', whiteSpace: 'nowrap' } },
            React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, billing.handle
                ? // @ts-ignore
                    lang.systemTankHandles[billing.handle] || billing.handle
                : '-')),
        React.createElement("td", { style: { width: '1%', whiteSpace: 'nowrap', fontSize: '0.8em' } },
            React.createElement(CopyToClipboard, { text: identity }, identity)),
        React.createElement("td", { title: moment(billing.date).format(THEME.DATE_FORMAT_LONG), style: { width: '140px', fontSize: '0.8em' } }, moment(billing.date).format(THEME.DATE_FORMAT)),
        React.createElement("td", { style: { fontSize: '0.8em', fontWeight: 900 } }, creditor &&
            (site == Site.Caseworker ? (
            // @ts-ignore
            React.createElement(Link, { style: { color: 'inherit' }, to: `/creditors/${creditor.creditorId}` }, creditor.name)) : (creditor.name))),
        React.createElement("td", { style: { fontSize: '0.8em' } }),
        React.createElement("td", { style: { textAlign: 'right', width: '1%', whiteSpace: 'nowrap' } }),
        React.createElement("td", { style: { textAlign: 'right', width: '1%', whiteSpace: 'nowrap' } }),
        React.createElement("td", { style: { width: '40px' } },
            React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, billing.currency)),
        React.createElement("td", { style: { width: '40px' } },
            React.createElement(X, { style: { cursor: 'pointer' }, onClick: () => __awaiter(void 0, void 0, void 0, function* () { }) })),
        React.createElement("td", { style: { width: '40px' } }, !billing.billingEmailed && (React.createElement(Send, { style: { cursor: 'pointer', height: '18px', width: '18px' }, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                yield billingsAPI.sendBillings([billing.billingId]);
            }) })))));
};
export default Billing;
const CIRCLE_WIDTH = 7;
const Circle = styled.div `
  height: ${CIRCLE_WIDTH}px;
  width: ${CIRCLE_WIDTH}px;
  margin-right: -${CIRCLE_WIDTH}px;
  background-color: ${THEME.SELECTED_BLUE};
  border-radius: 100%;
`;
//# sourceMappingURL=Billing.js.map